import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableStructure from "../../CommonComponents/TableStructure";
import { getAllGenresData } from "../../services/Genres";
import { setPreview } from "../../redux/actions/previewActions";

const GenresTable = () => {
  const [records, setRecords] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const isInitialLoad = useRef(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [sortOrder, setSortOrder] = useState("asc"); // Sorting state
  const session = useSelector((state) => state.session);
  const dispatch = useDispatch();
  const limit = 50; // Number of records per page

  // Fetch flip books from the API
  const fetchGenres = async (page, term) => {
    setLoading(true);
    try {
      const result = await getAllGenresData(limit, page, term);
      if (result?.data?.data) {
        setRecords(citationFactor(result.data.data || []));
        setTotalPages(Math.ceil(result.data.total / limit));
        setTotalRecords(result.data.total);
        if (result.data.page_number && parseInt(result.data.page_number) !== currentPage) {
          setCurrentPage(parseInt(result.data.page_number));
        }
        if (isInitialLoad.current) {
          isInitialLoad.current = false; // Skip the first render
        }
      }
    } catch (error) {
      console.error("Error fetching genres:", error);
    } finally {
      setLoading(false);
    }
  };


  const citationFactor = (data) => {
    return data?.map((item) => {
      return {
        name: item?.name || 'NA',
        alias: item?.alias || 'NA',
      }
    })
  }

  const columns = [
    {
      label: "Name",
      accessor: "name",
    },
    {
      label: "Alias",
      accessor: "alias",
    }
  ]

  // Handle search button click
  const handleSearch = (searchTerm) => {
    if (searchTerm.trim()) {
      isInitialLoad.current = false; // Skip the first render
      setCurrentPage(1); // Reset to page 1 for a new search
      setSearchText(searchTerm);
      fetchGenres(1, searchTerm);
    }
  };

  const sortRecords = () => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc"; // Update sortOrder first
    setSortOrder(newSortOrder);

    const sorted = [...records].sort((a, b) =>
      newSortOrder === "asc"
        ? a.alias.localeCompare(b.alias)
        : b.alias.localeCompare(a.alias)
    );

    setRecords(sorted);
  };


  useEffect(() => {

    fetchGenres(currentPage, searchText);
    dispatch(setPreview(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, dispatch]);

  const handleClear = () => {
    setSearchText('');
    fetchGenres(1, "");
  };

  // Handle page changes
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(parseInt(page));
    }
  };

  return (
    <TableStructure
      isAuthenticated={session?.isAuthenticated}
      handleSearch={handleSearch}
      handleClear={handleClear}
      handlePageChange={handlePageChange}
      currentPage={currentPage}
      totalPages={totalPages}
      sortRecords={sortRecords}
      sortOrder={sortOrder}
      totalRecords={totalRecords}
      loading={loading}
      records={records}
      type="genres"
      title="Genres"
      addOption
      columns={columns}
    />
  );
};

export default GenresTable;
